import { createClient } from "@connectrpc/connect";
import { ISaveService } from "../../../abstractions/services/actions/ISaveService";
import { grpcTransportProvider } from "../../../comun/services/grpc/GrpcTransport";
import { mapConnectError } from "../../../comun/services/grpc/mapConnectError";
import { createCachedFactory } from "../../../utils/factoryUtils";
import { TareaEjecucionService } from "../../../generated/grpc/rastro_tarea_ejecucion_pb";
import { TareaEjecucionAsignarTareaRequest } from "../request/TareaEjecucionAsignarTareaRequest";
import { fx_createTareaEjecucionGrpcService } from "./TareaEjecucionGrpcService";

/** Variante gRPC-Web de `TareaEjecucionAsignarTareaService` (ver ese
 *  archivo), con scope por finca. A diferencia de `Guardar`/`Eliminar`, esta
 *  sí invalida el cooldown del listado: la respuesta del rpc es vacía (mismo
 *  que el 204 de REST), así que no hay item actualizado para parchear en
 *  `GrpcTareaEjecucionDatabase` directo — hace falta un resync real para que
 *  el cliente vea las tareas recién asignadas. */
class TareaEjecucionAsignarTareaGrpcService
  implements
    ISaveService<
      TareaEjecucionAsignarTareaRequest,
      TareaEjecucionAsignarTareaRequest
    >
{
  constructor(private readonly _fincaId: string) {}

  async saveAsync(
    request: TareaEjecucionAsignarTareaRequest,
  ): Promise<TareaEjecucionAsignarTareaRequest> {
    const client = createClient(TareaEjecucionService, grpcTransportProvider.get());

    try {
      await client.asignarTarea({
        asignaciones: request.asignaciones.map((asignacion) => ({
          tareaEjecucionId: asignacion.tareaEjecucionId,
          tareaId: asignacion.tareaId,
        })),
      });
    } catch (error) {
      throw mapConnectError(error);
    }

    fx_createTareaEjecucionGrpcService(this._fincaId).clearCache();
    return request;
  }
}

/** Factory cacheada: una única instancia por fincaId (mismo criterio que
 *  `fx_createTareaEjecucionAsignarTareaService`). */
export const fx_createTareaEjecucionAsignarTareaGrpcService = createCachedFactory(
  (fincaId: string) => new TareaEjecucionAsignarTareaGrpcService(fincaId),
);
